module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-middle-a09bd9d9.svg";